import { useEffect, useState } from "react";

const KEY = "cocoon_screensaver";
const DEFAULTS = { enabled: true, delayMs: 60000 };
const subs = new Set();

export function getScreensaverPrefs() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULTS };
    return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULTS };
  }
}

export function setScreensaverPrefs(patch) {
  const next = { ...getScreensaverPrefs(), ...patch };
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {}
  subs.forEach((cb) => cb(next));
  return next;
}

export function useScreensaverPrefs() {
  const [prefs, setPrefs] = useState(getScreensaverPrefs());
  useEffect(() => {
    const cb = (p) => setPrefs(p);
    subs.add(cb);
    return () => subs.delete(cb);
  }, []);
  return prefs;
}
